import React, { createContext, useContext, ReactNode, useState, useCallback } from 'react';

export enum MobileMenuViews {
  Root = 'More',
  SendInvoice = 'Send Payment',
  SnoozeNotifications = 'Snooze Notifications',
  ChangeClinics = 'Change Clinic',
}

interface IMobileMenuProvider {
  setCurrentMobileMenuView: (view: MobileMenuViews) => void;
  currentMobileMenuView: MobileMenuViews;
}

const MobileMenuContext = createContext<IMobileMenuProvider>({
  currentMobileMenuView: MobileMenuViews.Root,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setCurrentMobileMenuView: (view: MobileMenuViews): void => {
    throw new Error('setCurrentMobileMenuView(view: MobileMenuViews): void not implemented');
  },
});

interface MobileMenuProviderProps {
  children: ReactNode;
}

export const useMobileMenuProvider = (): IMobileMenuProvider => useContext<IMobileMenuProvider>(MobileMenuContext);

const MobileMenuProvider = ({ children }: MobileMenuProviderProps): JSX.Element => {
  const [currentMobileMenuView, setCurrentMobileMenuView] = useState(MobileMenuViews.Root);

  const updateMobileMenuView = useCallback((view: MobileMenuViews) => {
    setCurrentMobileMenuView(view);
  }, []);

  return (
    <MobileMenuContext.Provider
      value={{
        setCurrentMobileMenuView: updateMobileMenuView,
        currentMobileMenuView,
      }}
    >
      {children}
    </MobileMenuContext.Provider>
  );
};

export default MobileMenuProvider;
